import { gql, TypedDocumentNode } from '@apollo/client';
import { backendResponse } from '../../../common_lib_front/types/backendResponse';
import VehicleInfo from '../../../common_lib_front/types/vehicleInfo';
import { backendClient } from '../../../common_lib_front/utilities/BackendAPI';

type editVehicleType = {
  color?: string;
  type?: string;
  licensePlate?: string;
};

export const mapVehicleInfoToEditData = (
  data: VehicleInfo,
  defaults?: Partial<VehicleInfo>,
) => ({
  color: data.color || defaults?.color || undefined,
  destinationAddressId:
    data.destinationAddressId || defaults?.destinationAddressId || undefined,
  isRental: data.isRental || defaults?.isRental || undefined,
  licensePlate: data.licensePlate || defaults?.licensePlate || undefined,
  licensePlateState: data.licensePlateState || defaults?.licensePlateState || undefined,
  licensePrimaryDriver:
    data.licensePrimaryDriver || defaults?.licensePrimaryDriver || undefined,
  make: data.make || defaults?.make || undefined,
  primaryDriverName: data.primaryDriverName || defaults?.primaryDriverName || undefined,
  type: data.type || defaults?.type || undefined,
  vehicleModel: data.vehicleModel || defaults?.vehicleModel || undefined,
  year: data.year || defaults?.year || undefined,
});

export type REGISTER_VEHICLE_VARS = {
  passId: string;
  passInfoId: string;
  vehicleInfo: ReturnType<typeof mapVehicleInfoToEditData>;
  propertySlug: string;
};

export type REGISTER_VEHICLE_RES = {
  registerVehicle: backendResponse<undefined>;
};
export const REGISTER_VEHICLE: TypedDocumentNode<
  REGISTER_VEHICLE_RES,
  REGISTER_VEHICLE_VARS
> = gql`
  mutation ThisSaveVehicle(
    $passId: String!
    $passInfoId: String!
    $vehicleInfo: ActuallyInputTypeVehicleInput!
    $propertySlug: String!
  ) {
    registerVehicleWithoutContext(
      passId: $passId
      passInfoId: $passInfoId
      vehicleInfo: $vehicleInfo
      propertySlug: $propertySlug
    ) {
      success
      error
    }
  }
`;

export function mutateWrapperForVehiclePass(
  data: REGISTER_VEHICLE_VARS,
): Promise<REGISTER_VEHICLE_RES> {
  return backendClient
    .mutate<REGISTER_VEHICLE_RES, REGISTER_VEHICLE_VARS>({
      mutation: REGISTER_VEHICLE,
      variables: data,
    })
    .then((res: any) => res.data);
}

export type EDIT_VEHICLE_VARS = {
  newVehicleInfo: ReturnType<typeof mapVehicleInfoToEditData>;
  vehicleId: string;
  passInfoId: string;
};
export type EDIT_VEHICLE_RES = {
  editVehicle: backendResponse<undefined>;
};
export const EDIT_VEHICLE = gql`
  mutation EditVehicle(
    $newVehicleInfo: ActuallyInputTypeVehicleInput!
    $vehicleId: String!
    $passInfoId: String
  ) {
    editVehicle(
      newVehicleInfo: $newVehicleInfo
      vehicleId: $vehicleId
      passInfoId: $passInfoId
    ) {
      success
      error
      data {
        vehicleId
      }
    }
  }
`;
